import { AudioPodClient } from '../client/AudioPodClient';
import { Job } from '../types';

export class SpeakerService {
  constructor(private client: AudioPodClient) {}

  async diarizeSpeakers(
    audioFile: File | Blob | string,
    numSpeakers?: number,
    waitForCompletion: boolean = false,
    timeout: number = 600000
  ): Promise<any> {
    let fileData: File | Blob;
    if (typeof audioFile === 'string') {
      const fs = await import('fs');
      const fileBuffer = fs.readFileSync(audioFile);
      fileData = new Blob([fileBuffer], { type: 'audio/*' });
    } else {
      fileData = audioFile;
    }

    const formData: Record<string, any> = {};
    if (numSpeakers) formData.num_speakers = numSpeakers;

    const job = await this.client.uploadFile<Job>('/speaker/diarize', fileData, formData);

    if (waitForCompletion) {
      return this.client.waitForJobCompletion(job.id, timeout);
    }
    return { job };
  }
}
